module.exports = __webpack_public_path__ + "img/IMG_6416 1.9d0e4b4a.webp";